import styled from "styled-components"

const List = styled.ul`
  list-style-type: none;
`

export const ListItem = styled.li`
  font-weight: bolder;
  font-size: 1rem;
  border-bottom: ${(props: any) => (props.border ? "1px solid #f8f8f8" : 0)};
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  color: ${(props) => props.theme.colors.grey};
`

export default List
